<template>
    <span id="brasilia-clock">
        <i class="fa fa-exclamation-triangle"></i>
        Horário oficial: Horário de Brasília — {{ brasiliaTime }}
    </span>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';

const brasiliaTime = ref('');
let clockInterval = null;

function updateClock() {
    brasiliaTime.value = new Date().toLocaleTimeString('pt-BR', {
        timeZone: 'America/Sao_Paulo',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    });
}

onMounted(() => {
    updateClock();
    clockInterval = setInterval(updateClock, 60000);
});

onBeforeUnmount(() => {
    clearInterval(clockInterval);
});
</script>
